import tippy from "tippy.js";

function activatePopper(el) {
  const els = document.querySelectorAll(el);

  for (const el of els) {
    const popupSelector = el.getAttribute('data-popup');
    const popup = document.querySelector(popupSelector);

    tippy(el, {
      html: popup,
      popperOptions: {
        modifiers: {
          offset: {
            offset: el.getAttribute('data-offset') || 0,
          },
        },
      },
    });

    if (popup) {
      popup.style.display = null;
    }
  }
}

export default activatePopper;
